import { isNonNull, StartersDispensationQuestion } from '@hb/domain';
import { ApplicantsStoreService } from '@hb/modules/applicants/applicants-store.service';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, filter, skip } from 'rxjs';

import { StartersDispensation } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class StartersDispensationStore extends AbstractStoreInjectOption<StartersDispensationQuestion> implements OnDestroy {
    protected readonly store = inject(ApplicantsStoreService);
    protected readonly lastQuestion = StartersDispensationQuestion.SUMMARY;

    private readonly startersDispensationSubject: BehaviorSubject<StartersDispensation>;

    constructor() {
        super();
        this.init();
        const initialValues = this.getInitialValues();
        this.startersDispensationSubject = new BehaviorSubject<StartersDispensation>(initialValues);
        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.activeQuestionSubject.unsubscribe();
        this.startersDispensationSubject.unsubscribe();
    }

    getInitialValues(): StartersDispensation {
        return this.store.getApplicantsState()?.starters_dispensation;
    }

    update(): void {
        this.store.setStartersDispensation(this.startersDispensationSubject.value);
    }

    private subscriptions(): void {
        this.startersDispensationSubject
            .asObservable()
            .pipe(skip(1))
            .pipe(filter(isNonNull))
            .subscribe(() => {
                this.update();
                this.nextQuestion();
            });
    }
    getStartersDispensationObservable() {
        return this.startersDispensationSubject.asObservable();
    }

    getStartersDispensation() {
        return this.startersDispensationSubject.value;
    }

    setStartersDispensation(startersDispensation: StartersDispensation) {
        this.startersDispensationSubject.next(startersDispensation);
    }
}
